import { StepComponentType } from '@icc/configurator/shared';
import { AccessoriesComponent } from './accessories/accessories.component';

export const accessoryStepsMap: {
    [stepId: string]: StepComponentType;
} = {
    accessories: AccessoriesComponent,
};
